import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-chat-footer',
  templateUrl: './chat-footer.component.html',
  styleUrls: ['./chat-footer.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslatePipe]
})
export class ChatFooterComponent implements OnInit {
  @Input() message: string = '';
  /** Deshabilita por completo el footer (chat cerrado, contacto eliminado, límite del propietario...). */
  @Input() disabled: boolean = false;
  /**
   * Estado transitorio mientras se envía un mensaje. Deshabilita SOLO los botones,
   * no el textarea: si se deshabilitara el textarea perdería el foco y el teclado
   * se cerraría en cada envío (#6).
   */
  @Input() sending: boolean = false;
  @Input() isWeb: boolean = false;
  @Output() messageChange = new EventEmitter<string>();
  @Output() sendMessage = new EventEmitter<void>();
  @Output() sendImage = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onMessageChange(event: any) {
    // Obtener el valor del input desde el evento ionInput
    const newValue = event.detail.value || '';

    // Solo emitir si el valor ha cambiado
    if (this.message !== newValue) {
      this.message = newValue;
      this.messageChange.emit(this.message);
    }
  }

  onKeyDown(event: KeyboardEvent) {
    // Only alter behavior for web
    if (!this.isWeb) return;

    if (event.key === 'Enter') {
      // Shift + Enter => insert newline
      if (event.shiftKey) {
        event.preventDefault();
        const target = event.target as HTMLTextAreaElement | null;
        if (target) {
          const start = target.selectionStart || 0;
          const end = target.selectionEnd || 0;
          const val = this.message || '';
          const newVal = val.substring(0, start) + '\n' + val.substring(end);
          this.message = newVal;
          this.messageChange.emit(this.message);
          // move cursor after inserted newline
          setTimeout(() => {
            try { target.selectionStart = target.selectionEnd = start + 1 } catch(e) {}
          }, 0);
        }
      } else {
        // Enter alone => send
        event.preventDefault();
        this.onSendMessage();
      }
    }
  }

  onSendMessage() {
    if (!this.disabled && !this.sending && this.message.trim()) {
      this.sendMessage.emit();
    }
  }

  onSelectImage() {
    if (!this.disabled && !this.sending) {
      this.sendImage.emit();
    }
  }
}
